/** Raw fetch() calls to our API refresh an expired session once and retry, like api.request does. */
import api from './api';
import useAuthStore from './auth-store';

const BASE = process.env.REACT_APP_BACKEND_URL;

export function installAuthFetch() {
  const raw = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    const res = await raw(input, init);
    const headers = new Headers(init.headers || {});
    if (res.status !== 401 || !url.startsWith(`${BASE}/api/`) || url.includes('/api/auth/') || !headers.get('Authorization')
      || !localStorage.getItem('refresh_token')) return res;
    try {
      if (!api._refreshPromise) api._refreshPromise = api._refreshAccessToken();
      const token = await api._refreshPromise;
      api._refreshPromise = null;
      useAuthStore.setState({ token });
      headers.set('Authorization', `Bearer ${token}`);
      return raw(input, { ...init, headers });
    } catch {
      api._refreshPromise = null;
      return res;
    }
  };
}
